import { SelectionType } from 'owa-addins-core';
import { isGroupTableSelected } from 'owa-group-utils';
import { updateAddinOnItemNavigation } from 'owa-mail-addins';

export default function updateAddinOnNavigationToEmptyNullReadingPane(): void {
    if (isGroupTableSelected()) {
        updateAddinOnItemNavigation(SelectionType.NotSupported);
    } else {
        updateAddinOnItemNavigation(SelectionType.Empty);
    }
}
